import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import useGetAuthed from "../../../helpers/hooks/useGetAuthed";
import { Spinner } from "reactstrap";

const LineColumnChart = () => {
  const [authData2, errorAuth2, loadingAuth2, callAuth2] = useGetAuthed(
    "loan_analysis",
    true,
    "loan"
  );

  const [currentYearData, setCurrentYearData] = useState("");
  const [lastYearData, setLastYearData] = useState("");
  const [seriesData, setSeriesData] = useState([]);
  const [chartData, setChartData] = useState("");
  const [chartOptions, setChartOptions] = useState({});
  // const [thisyear, setThisYear] = useState("");
  // const [prevYear, setPrevYear] = useState("");

  useEffect(() => {
    if (authData2) {
      setCurrentYearData(authData2?.current_year_amounts);
      setLastYearData(authData2?.last_year_amounts);
      console.log(authData2);
    }
  }, [authData2]);

  useEffect(() => {
    if (currentYearData && lastYearData) {
      const thisyear = "Rs " + authData2?.this_year_amount.toLocaleString() + "/-";
      const prevYear = "Rs " + authData2?.pervious_year_amount.toLocaleString() + "/-";
      setSeriesData([
        {
          name:
            "Previous Year:   " +
            prevYear.toLocaleString("en-US", {
              maximumFractionDigits: 2,
            }),
          type: "column",
          data: lastYearData,
        },
        {
          name:
            "This Year:   " +
            thisyear.toLocaleString("en-US", {
              maximumFractionDigits: 2,
            }),
          type: "line",
          data: currentYearData,
        },
      ]);

      setChartOptions({
        chart: {
          stacked: false,
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: [0, 4],
          curve: "smooth",
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 5,
            columnWidth: "80%",
            endingShape: "rounded",
            colors: {
              backgroundBarColors: ["#f6fbfd"],
              backgroundBarOpacity: 2,
              backgroundBarRadius: 0,
            },
          },
        },
        colors: ["#f1ad02", "#26a682"],
        fill: {
          gradient: {
            inverseColors: false,
            shade: "light",
            type: "vertical",
            opacityFrom: 0.85,
            opacityTo: 0.55,
            stops: [0, 100, 100, 100],
          },
        },

        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          fontSize: "12px",
          fontFamily: "Helvetica, Arial",
          fontWeight: 400,
          inverseOrder: true,
          offsetX: 0,
          offsetY: 12,
          markers: {
            width: 12,
            height: 12,
            radius: 3,
          },
          itemMargin: {
            horizontal: 20,
            vertical: 0,
          },
          onItemClick: {
            toggleDataSeries: false,
          },
          formatter: function (seriesName, opts) {
            if (
              seriesName.includes("This Year") ||
              seriesName.includes("Previous Year")
            ) {
              const color = seriesName.includes("This Year")
                ? "#26a682"
                : "#f1ad02";
              return (
                '<div style="display: flex; align-items: center; margin-top:7px">' +
                '<h6 style="color: ' +
                color +
                '; margin-right: 5px;">' +
                seriesName +
                "</h6>" +
                '<span style="color: ' +
                color +
                ';"> </span>' +
                "</div>"
              );
            } else {
              return (
                '<div style="display: flex; align-items: center; margin-top:7px"><h6 style="font-weight: bold; margin-right: 5px;">' +
                seriesName +
                "</h6></div>"
              );
            }
          },
        },

        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
          type: "category",
        },
        yaxis: {
          title: {
            text: "Cash",
          },
          labels: {
            formatter: function (value) {
              // Convert value to millions and format with commas
              if (value >= 1000) {
                return (value / 1000).toLocaleString('en-US') + "K";
              }
              return value.toLocaleString('en-US');
            },
          },
          
        },
        tooltip: {
          shared: true,
          intersect: false,
          fillSeriesColor: false,
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            let months = [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ];

            let monthName = months[dataPointIndex];
            let value1 = series[0][dataPointIndex].toLocaleString();
            let value2 = series[1][dataPointIndex].toLocaleString();

            return (
              '<div class="arrow_box d-flex flex-column mb-10 text-center" style="width: auto;">' +
              '<span class="border-bottom" style="background-color: #f3b928;">' +
              monthName +
              "</span>" +
              '<div style="width: 100%; text-align: left; margin-top:10px; padding:2px">' +
              '<span style="display: inline-block;"> • <span style="color: #f3b928; font-weight: 600;">2022:</span> ' +
              '<span style="color: #f3b928; font-weight: 600;">' +
              value1 +
              "</span>" +
              "</span>" +
              "</div>" +
              '<div style="width: 100%; text-align: left; padding:2px">' +
              '<span style="display: inline-block;"> • <span style="color: #2da682; font-weight: 600;">2023:</span> ' +
              '<span style="color: #2da682; font-weight: 600;">' +
              value2 +
              "</span>" +
              "</span>" +
              "</div>" +
              "</div>"
            );
          },
          y: {
            formatter: function (y) {
              if (typeof y !== "undefined") {
                return y.toFixed(0);
              }
              return y;
            },
          },
          marker: {
            show: true,
          },
        },
        title: {
          text: "Loan Request Analysis",
          align: "left",
          style: {
            fontSize: "22px",
          },
        },
      });
    }
  }, [currentYearData, lastYearData]);

  useEffect(() => {
    if (seriesData.length > 0) {
      setChartData({
        series: seriesData,
        options: chartOptions,
      });
    }
  }, [seriesData, chartOptions]);

  // Set state for chart data

  return (
    <React.Fragment>
      <div>
        {loadingAuth2 ? (
          <div className="text-center" style={{ marginTop: "40px" }}>
            <Spinner className="mr-2" color="success" />
          </div>
        ) : (
          chartData && (
            <ReactApexChart
              options={chartData.options}
              series={chartData.series}
              type="line"
              height="330px"
              style={{ border: "0.5px solid #bfc7d9", borderRadius: "10px" }}
            />
          )
        )}
      </div>
    </React.Fragment>
  );
};

export default LineColumnChart;
